import { render, staticRenderFns } from "./SbbBinMeasurement.vue?vue&type=template&id=3528899a&scoped=true&"
import script from "./SbbBinMeasurement.vue?vue&type=script&lang=js&"
export * from "./SbbBinMeasurement.vue?vue&type=script&lang=js&"
import style0 from "./SbbBinMeasurement.vue?vue&type=style&index=0&id=3528899a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3528899a",
  null
  
)

/* custom blocks */
import block0 from "./SbbBinMeasurement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports